import { contentRegistry } from './buildContentRegistry';
import { getDocumentById } from './getDocumentById';
const comparePublishedAtDesc = (a, b) => (b.meta?.publishedAt?.getTime() ?? 0) - (a.meta?.publishedAt?.getTime() ?? 0);
const comparePublishedAtAsc = (a, b) => (a.meta?.publishedAt?.getTime() ?? 0) - (b.meta?.publishedAt?.getTime() ?? 0);
const compareTitleAsc = (a, b) => a.seo.title.localeCompare(b.seo.title);
const getRelatedDocuments = (documentId) => {
    const source = getDocumentById(documentId);
    if (!source) {
        return [];
    }
    const explicit = source.relations?.relatedDocumentIds
        ?.map((id) => getDocumentById(id))
        .filter((document) => Boolean(document));
    if (explicit?.length) {
        return explicit;
    }
    const sourceTags = source.meta?.tags ?? [];
    if (sourceTags.length === 0) {
        return [];
    }
    return contentRegistry.documents
        .filter((document) => document.id !== source.id)
        .filter((document) => Boolean(document.meta?.tags?.some((tag) => sourceTags.includes(tag))))
        .sort(comparePublishedAtDesc);
};
export const listDocuments = ({ kind, tag, tags, relatedTo, sortBy, } = {}) => {
    let documents = relatedTo
        ? getRelatedDocuments(relatedTo)
        : [...contentRegistry.documents];
    if (kind) {
        documents = documents.filter((document) => document.kind === kind);
    }
    const allTags = [...(tag ? [tag] : []), ...(tags ?? [])];
    if (allTags.length > 0) {
        documents = documents.filter((document) => allTags.every((tagName) => document.meta?.tags?.includes(tagName)));
    }
    const resolvedSort = sortBy ??
        (kind === 'blog' || kind === 'report' ? 'publishedAt-desc' : 'title-asc');
    return [...documents].sort((a, b) => {
        if (resolvedSort === 'publishedAt-asc') {
            return comparePublishedAtAsc(a, b);
        }
        if (resolvedSort === 'title-asc') {
            return compareTitleAsc(a, b);
        }
        return comparePublishedAtDesc(a, b);
    });
};
//# sourceMappingURL=listDocuments.js.map